// componentes/ActionBar.js
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
const formatNumber = (value) => {
  if (!value && value !== 0) return '';
  
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) return '';
  
  const [entero, decimal] = numValue.toFixed(2).split('.');
  const enteroFormateado = entero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  return `${enteroFormateado},${decimal}`;
};


const ActionBar = ({ 
  onAgregarProductos, 
  subtotal, 
  totalIva, 
  totalGeneral 
}) => (
  <Box
    sx={{
      mb: 2,
      display: "flex",
      justifyContent: "flex-end", // Cambiado de "space-between" a "flex-end"
      alignItems: "center",
    }}
  >
    {/* <Button
      variant="contained"
      startIcon={<AddIcon />}
      onClick={onAgregarProductos}
    >
      Agregar Productos
    </Button> */}
    

    <Box sx={{ display: "flex", gap: 4 }}>
      <Typography variant="body1">
        <strong>Subtotal:</strong> ${formatNumber(subtotal)}
      </Typography>
      <Typography variant="body1">
        <strong>IVA:</strong> ${formatNumber(totalIva)}
      </Typography>
      <Typography variant="h6" color="primary">
        <strong>Total:</strong> ${formatNumber(totalGeneral)}
      </Typography>
    </Box>
  </Box>
);

export default ActionBar;